module.exports = __webpack_public_path__ + "static/media/lifeline.120c8a3f.svg";